module.exports = __webpack_public_path__ + "img/remap_logo2.247815b8.png";